var exports = {
  "A7": "xe564cbfb--080206--outer",
  "R": "xe564cbfb--080206--hidden",
  "RK": "xe564cbfb--080206--visible",
  "vW": "xe564cbfb--080206--inner",
};

module.exports = exports;
